<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica Tipo pagamento' : 'Nuova Tipo pagamento' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-payment-type-form [data]="data"></app-payment-type-form>
</div>
